import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=4560a9ea&scoped=true"
import script from "./quillEditor.vue?vue&type=script&lang=js"
export * from "./quillEditor.vue?vue&type=script&lang=js"
import style0 from "./quillEditor.vue?vue&type=style&index=0&id=4560a9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560a9ea",
  null
  
)

component.options.__file = "quillEditor.vue"
export default component.exports